import { render, staticRenderFns } from "./icon-tile-group.vue?vue&type=template&id=1611003d&"
import script from "./icon-tile-group.vue?vue&type=script&lang=js&"
export * from "./icon-tile-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports